import { MessageType } from "../../Constant";
import {
  fetchGeneratedReportsService,
  fetchReportDownloadableLink,
  fetchReportNames,
  generateReport,
} from "../../services/reportsModuleService";
import { hideLoading, resetLoading, showLoading } from "../../shared/widgets";
import { setTokenExpired } from "../actions/authActions";
import { setNotificationMessage } from "../actions/notificationAction";
import {
  reportTypesFetched,
  userGeneratedReportsFetched,
} from "../actions/reportsModuleActions";
import { createAllActionCreators } from "./actionCreatorUtil";

const reportsModuleActionCreators = {
  fetchReportNamesAction: {
    service: fetchReportNames,
    action: reportTypesFetched,
    dataAccessor: { status: false },
  },
  fetchUserGeneratedReportsAction: {
    service: fetchGeneratedReportsService,
    action: userGeneratedReportsFetched,
  },
  getLinkAndDownloadReportAction: {
    loaderType: "loadingPDF",
    service: fetchReportDownloadableLink,
    responseFn: (response, params) => {
      const { dispatch, loaderType } = params;
      window.open(response.body.link);
      dispatch(hideLoading(loaderType));
    },
  },
};

export const {
  fetchReportNamesAction,
  fetchUserGeneratedReportsAction,
  getLinkAndDownloadReportAction,
} = createAllActionCreators(reportsModuleActionCreators);

export const generateReportAction = (
  selectCityList,
  selectedReportType,
  fromDate,
  toDate,
  pageNo,
  pageSize,
  loaderScope,
) => (dispatch) => {
  dispatch(resetLoading(loaderScope));
  dispatch(showLoading(loaderScope));
  generateReport(selectCityList, selectedReportType, fromDate, toDate)
    .then((response) => {
      if (response?.success) {
        dispatch(
          setNotificationMessage({
            type: MessageType.SUCCESS,
            message:
                response.message || "Report generation quoted successfully",
          }),
        );
      }
      dispatch(fetchUserGeneratedReportsAction({ pageNo, pageSize }));
      dispatch(hideLoading(loaderScope));
    })
    .catch((err) => {
      if (err.message.includes("Invalid token")) {
        dispatch(setTokenExpired(true));
      } else {
        dispatch(
          setNotificationMessage({
            type: MessageType.ERROR,
            message: err.message || "Something went wrong",
          }),
        );
        dispatch(hideLoading(loaderScope));
      }
    });
};
